import PropTypes from 'prop-types';

const VisibleIf = ({ isVisible = false, children }) => (isVisible ? children : null);

VisibleIf.propTypes = {
    isVisible: PropTypes.bool,
    children: PropTypes.node.isRequired,
};

export default VisibleIf;
